module.exports = __webpack_public_path__ + "media/images/img-regist-info-804978f1.png";